import { httpRequest } from "../../http";

export class CommandUpdateTeamMember {
  

    async run(organizationId: number,  employeeId: number, body: any) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organization/${organizationId}/team/${employeeId}/`
        try {
            const response = await httpRequest<any>(url, { method: "PUT", body });
            return response;
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }

    }


  
}
